module.exports = __webpack_public_path__ + "img/photos/sla01a.jpg";